<template>
	<div class="color">
		<div v-for="(bin, index) in colorBins"
			v-if="bin > 0"
			:key="index"
			:style="{
				width: binWidth(bin, colorTotal),
				background: colorCode(index)
			}">
			<div class="preview"
				v-bind:style="{ background: colorCode(index) }">
			</div>
			<label v-bind:style="{ color: textColorCode(index) }">
				{{ binLabel(bin, colorTotal) }}
			</label>
			<span class="count">
				{{ bin }}
			</span>
		</div>
	</div>
</template>
<script>
import ExcretionAnalysis from '.'

export default {
	name: 'patient-excretion-card-color-analysis',
	extends: ExcretionAnalysis
}
</script>

<style lang="scss" scoped>

.color {
	padding-left: 60px;
	padding-right: 30px;

	> div {
		position: relative;
		height: 20px;
		margin-bottom: 10px;

		.preview, label, .count {
			position: absolute;
		}
		.preview {
			width: 20px;
			height: 20px;
			border: solid 2px rgba(0, 0, 0, 0.2);
			left: -30px;
			top: 0px;
		}
		label {
			color: #3f3f3f;
			left: 10px;
			top: 5px;
			font-size: 12px;
			font-weight: 700;
			letter-spacing: 1px;
		}
		.count {
			color: #9f9f9f;
			font-size: 16px;
			font-weight: 700;
			line-height: 20px;
			right: 0;
			width: 55px;
			margin-right: -60px;
			text-align: left;
		}
	}
}
</style>
